module.exports = __webpack_public_path__ + "img/cloud-fill.2598fcd7.svg";